(function () {
  'use strict';

  angular
    .module('app')
    .controller('headerController', headerController);

  headerController.$inject = ['$scope', 'searchService', '$location'];
  function headerController($scope, searchService, $location) {

    /* jshint validthis:true */
    var vm = this;
    vm.searchresults = [];
    vm.noResults = null;
    vm.searchfreetext = searchfreetext;
    vm.closeSearch = closeSearch;
    vm.getNextResults = getNextResults;
    vm.totalsearchresults = 0;
    vm.query = null;
    vm.viewMoreText = null;
    vm.loading = false;
    vm.showCloseSearch = true;


    function searchfreetext() {
      if (vm.query.length > 2) {
        vm.loading = true;
        searchService.freetextsearch(vm.query, 10, 0).then(function (result) {         
          if (result && result.data) {
            vm.searchresults = result.data.searchResults || [];
            vm.totalsearchresults = result.data.totalResults || 0;
            vm.viewMoreText = result.data.viewMoreText;
            vm.noResults = result.data.noResults;
          }
        },
          function (error) {
            console.log(error);
          })
          .then(function () {
            vm.loading = false;
            vm.showCloseSearch = true;
          });
      }
    }

    function closeSearch() {
      // var field = $('.mobile-search-container > input');
      var field = $('.c-mobile-search > input');
      field.val('');
      vm.query = '';
      vm.showCloseSearch = false;
    }

    function getNextResults() {
      if ((vm.searchresults || []).length < 10) return;

      vm.loading = true;
      searchService.freetextsearch(vm.query, 10, vm.searchresults.length).then(function (result) {
        if (result && result.data) {
          for (var i = 0; i < result.data.searchResults.length; i++) {
            vm.searchresults.push(result.data.searchResults[i]);
            vm.totalsearchresults = result.data.totalResults;
          }
          vm.viewMoreText = result.data.viewMoreText;
        }
      },
        function (error) {
          console.log(error);
        })
        .then(function () {
          vm.loading = false;
        });
    }
  }
})();
